/* global I18n */

import { isEmpty } from 'lodash';
import toast from './toast';

function checkClipboard() {
  if (!navigator.clipboard) {
    toast.warning('Su navegador no permite usar el portapapeles');
    return false;
  }
  return true;
}

/**
 * Emails es un array de strings con los emails
 */
// eslint-disable-next-line import/prefer-default-export
export function emailsToClipboard(emails) {
  if (!checkClipboard()) {
    return;
  }

  if (!isEmpty(emails)) {
    navigator.clipboard.writeText(emails.join(';'));
    toast.info(I18n.t('copiados_n_emails', { count: emails.length }));
  } else {
    toast.warning(I18n.t('copiados_n_emails', { count: 0 }));
  }
}
